import { render, staticRenderFns } from "./table-view-body-goal-setting.component.vue?vue&type=template&id=120ad3c4&scoped=true"
import script from "./table-view-body-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./table-view-body-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./table-view-body-goal-setting.component.vue?vue&type=style&index=0&id=120ad3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ad3c4",
  null
  
)

export default component.exports